import React from 'react';
import Tag from 'core/components/Tag';

type DeprecatedTagProps = Omit<React.ComponentProps<typeof Tag>, 'children'>;

const DeprecatedTag = (props: DeprecatedTagProps) => (
  <Tag intent="warning" monospace minimal {...props}>
    DEPRECATED
  </Tag>
);

export default DeprecatedTag;
